import { useState, useMemo } from "react";
import { dateFormat, successMessageToast, userFullName } from "helpers/common";
import downArrow from "Assets/images/downArrowPurple.png"
import upArrow from "Assets/images/upArrowPurple.png"
import downArrowNormal from "Assets/images/downArrowBlack.png"
import { store } from "store/store";
import { Button } from "react-bootstrap";
import AssignApprenticePop from "components/Modals/AssignApprenticePop";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDeleteApprenticeMutation } from "store/services/clients/apprentice";
import LoadingOverlay from "components/shared/LoadingOverlay";

const CliniciansAssignedComponent = ({ clientDetails, refetch }) => {

    const state = store.getState();
    const user = state.auth.user;

    const [sortField, setSortField] = useState("name");  // "name" | "discipline"
    const [sortOrder, setSortOrder] = useState("asc");   // "asc" | "desc"
    const [showAddApprenticeModal, setShowAddApprenticeModal] = useState(false);
    const [therapistCaseloadId, setTherapistCaseloadId] = useState(null);
    const [currentApprenticeId, setCurrentApprenticeId] = useState(null);
    const [showDeleteApprenModal, setShowDeleteApprenModal] = useState(false);
    const [deleteApprentice, { isLoading: deleteLoading }] = useDeleteApprenticeMutation()

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    // Flatten the nested mapping first
    const formattedData = useMemo(() => {
        const list =
            clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist
                ?.flatMap(item =>
                    item?.clientCaseloadMapping
                        ?.filter(x => x?.caseTherapist?.therapist_detail?.type === "veteran")
                        ?.map(caseloadMapping => ({
                            name: userFullName(caseloadMapping?.caseTherapist),
                            discipline: item?.caseDiscipline?.assign_term,
                            raw: { item, caseloadMapping }
                        }))
                ) || [];

        return list;
    }, [clientDetails]);

    // Sorting logic
    const sortedData = useMemo(() => {
        return [...formattedData].sort((a, b) => {
            let A = "", B = "";

            if (sortField === "name") {
                A = a.name?.toLowerCase() || "";
                B = b.name?.toLowerCase() || "";
            }

            if (sortField === "discipline") {
                A = a.discipline?.toLowerCase() || "";
                B = b.discipline?.toLowerCase() || "";
            }

            if (sortOrder === "asc") return A > B ? 1 : -1;
            return A < B ? 1 : -1;
        });
    }, [formattedData, sortField, sortOrder]);

    console.log('therapistCaseloadId', therapistCaseloadId)

    const handleDeleteApprentice = async () => {
        try {
            setShowDeleteApprenModal(false)
            const resp = await deleteApprentice({ caseloadId: therapistCaseloadId, currentApprenticeId }).unwrap()
            console.log("respsps", resp)
            if (resp.status === "success") {
                successMessageToast(resp?.message)
            }

        } catch (error) {
            console.error(error);
        }
        refetch()
    }
    return (
        <>
            <AssignApprenticePop
                show={showAddApprenticeModal}
                setShow={setShowAddApprenticeModal}
                caseloadId={therapistCaseloadId}
                refetch={refetch}
                currentApprenticeId={currentApprenticeId}
            />
            <ConfirmationPop
                confirmation={showDeleteApprenModal}
                setConfirmation={setShowDeleteApprenModal}
                confirmHandler={handleDeleteApprentice}
                type="remove"
            />
            {deleteLoading && <LoadingOverlay />}
            <div className="mt-2">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th
                                onClick={() => handleSort("name")}
                                className={`fw-medium cursor-pointer ${sortField === "name" && "themePurple"}`}
                                style={{ padding: "15px 10px", width: "40%", borderBottom: "2px solid #315D99" }}
                            >
                                NAME
                                <img
                                    width={9}
                                    height={9}
                                    className="ms-2"
                                    src={
                                        sortField === "name"
                                            ? sortOrder === "asc" ? upArrow : downArrow
                                            : downArrowNormal
                                    }
                                    alt="downArrow"
                                />
                            </th>

                                <th
                                className={`fw-medium cursor-pointer`}
                                style={{ padding: "15px 10px", width: "25%", borderBottom: "2px solid #315D99" }}
                            >
                                ASSIGNED ON
                                {/* <img
                                    width={9}
                                    height={9}
                                    className="ms-2"
                                    src={
                                        sortField === "name"
                                            ? sortOrder === "asc" ? upArrow : downArrow
                                            : downArrowNormal
                                    }
                                    alt="downArrow"
                                /> */}
                            </th>

                            <th
                                onClick={() => handleSort("discipline")}
                                className={`fw-medium text-end cursor-pointer ${sortField === "discipline" && "themePurple"}`}
                                style={{ padding: "15px 10px", width: "35%", borderBottom: "2px solid #315D99" }}
                            >
                                DISCIPLINE
                                <img
                                    width={9}
                                    height={9}
                                    className="ms-2"
                                    src={
                                        sortField === "discipline"
                                            ? sortOrder === "asc" ? upArrow : downArrow
                                            : downArrowNormal
                                    }
                                    alt="downArrow"
                                />
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {sortedData?.length > 0 ? (
                            sortedData.map((row, index) => {
                                const { item, caseloadMapping } = row.raw;
                                console.log('row', row)
                                const apprenticeFound = item.clientCaseloadMapping.find(
                                    x => x?.caseTherapist?.therapist_detail?.type === "apprentice"
                                );

                                const veteranFound = item.clientCaseloadMapping.find(
                                    x => x?.caseTherapist?.therapist_detail?.type === "veteran"
                                );

                                const isVeteranUser = user?.role_type === "veteran";
                                const isDischarged =
                                    item?.caseServiceStatus?.title?.toLowerCase() === "discharge";
                                return (
                                    <>
                                        <tr key={index}>
                                            <td style={{ padding: "15px 10px", borderBottom: (!apprenticeFound && caseloadMapping?.therapist_id != user?.id) && "1px solid #8F8F8F", borderRadius: 0 }}>
                                                {row.name}
                                            </td>
                                            <td style={{ padding: "15px 10px", borderBottom: (!apprenticeFound && caseloadMapping?.therapist_id != user?.id) && "1px solid #8F8F8F", borderRadius: 0 }}>
                                                {row?.raw?.item?.createdAt ? dateFormat(row?.raw?.item?.createdAt, "DD MMM, YYYY") : ""}
                                            </td>
                                            <td className="text-end" style={{ padding: "15px 10px", borderBottom: (!apprenticeFound && caseloadMapping?.therapist_id != user?.id) && "1px solid #8F8F8F", borderRadius: 0 }}>
                                                <span
                                                    className={`discipline-${row.discipline}-capsule-bcg`}
                                                    style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}
                                                >
                                                    {row.discipline}
                                                </span>
                                            </td>
                                        </tr>
                                        {/* Change Apprentice */}
                                        {
                                            <tr>
                                                {veteranFound && apprenticeFound && (
                                                    <td style={{ borderBottom: "1px solid #8F8F8F", borderRadius: 0 }} colSpan={3}>
                                                        <div className="px-2 py-2  align-items-center">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <p><span style={{ fontWeight: "600" }}>Apprentice: </span> {userFullName(apprenticeFound?.caseTherapist)}</p>
                                                                {
                                                                    caseloadMapping?.therapist_id == user?.id &&
                                                                    <div className="d-flex gap-2">
                                                                        <Button
                                                                            style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                            // disabled={clientDetails?.status != 'active'}
                                                                            disabled={['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                                                            onClick={() => {
                                                                                setTherapistCaseloadId(item.id);
                                                                                setCurrentApprenticeId(apprenticeFound.therapist_id);
                                                                                setShowAddApprenticeModal(true);
                                                                            }}
                                                                            className="commonBtn"
                                                                        >
                                                                            Change
                                                                        </Button>
                                                                        <Button
                                                                            style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                            // disabled={clientDetails?.status != 'active'}
                                                                            disabled={['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                                                            onClick={() => {
                                                                                setTherapistCaseloadId(item.id);
                                                                                setCurrentApprenticeId(apprenticeFound.therapist_id);
                                                                                setShowDeleteApprenModal(true);
                                                                            }}
                                                                            className="commonBtn"
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </td>
                                                )}

                                                {/* Assign Apprentice */}
                                                {
                                                    (!apprenticeFound && isVeteranUser && caseloadMapping?.therapist_id == user?.id) && (
                                                        <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: 0 }} colSpan={3} className="">
                                                            <div className="d-flex ">
                                                                <Button
                                                                    style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                    disabled={isDischarged}
                                                                    onClick={() => {
                                                                        setTherapistCaseloadId(item.id);
                                                                        setCurrentApprenticeId(null);
                                                                        setShowAddApprenticeModal(true);
                                                                    }}
                                                                    className="commonBtn"
                                                                >
                                                                    Assign Apprentice
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                            </tr>
                                        }
                                    </>
                                )
                            }
                            )
                        ) : (
                            <tr>
                                <td colSpan="2" className="text-center p-3">No Record Found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default CliniciansAssignedComponent;
